// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Twitter = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M6.836 17.025c7.453 0 11.53-6.174 11.53-11.529 0-.175 0-.35-.013-.524a8.244 8.244 0 0 0 2.022-2.097 8.088 8.088 0 0 1-2.327.637 4.067 4.067 0 0 0 1.781-2.24 8.12 8.12 0 0 1-2.573.983 4.056 4.056 0 0 0-6.905 3.695A11.504 11.504 0 0 1 2 1.717a4.055 4.055 0 0 0 1.254 5.409 4.022 4.022 0 0 1-1.839-.507v.051a4.054 4.054 0 0 0 3.25 3.972 4.046 4.046 0 0 1-1.829.07 4.056 4.056 0 0 0 3.786 2.814 8.13 8.13 0 0 1-5.997 1.68 11.472 11.472 0 0 0 6.211 1.816"
			fill="#1DA1F2"
		/>
	</svg>
);
export default Twitter;
